import { render, staticRenderFns } from "./LawEventList.vue?vue&type=template&id=21fc2b1a&"
import script from "./LawEventList.vue?vue&type=script&lang=js&"
export * from "./LawEventList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports